import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import {
    faCog,
    faUser,
    faCloudUploadAlt,
    faCheckCircle as faCheckCircleRegular,
    faSpinner,
    faTimesCircle,
    faBallotCheck as farBallotCheck,
    faBooks as farBooks,
    faFileAlt as farFileAlt,
    faBook as farBook,
    faInfoSquare as farInfoSquare,
    faInfo as farInfo,
    faInfoCircle as farInfoCircle,
    faFilePdf as farFilePdf,
    faBallot as farBallot,
    faFileSearch as farFileSearch,
    faBookAlt as farBookAlt,
    faBookOpen as farBookOpen,
    faPenSquare as farPenSquare,
    faEyeSlash,
} from '@fortawesome/pro-regular-svg-icons'

import {
    faTimes,
    faHome,
    faFile,
    faFileAlt,
    faFileDownload,
    faBriefcase,
    faTasks,
    faUsers,
    faBallotCheck as falBallotCheck,
    faBooks as falBooks,
    faFileAlt as falFileAlt,
    faBook as falBook,
    faInfoSquare as falInfoSquare,
    faInfo as falInfo,
    faInfoCircle as falInfoCircle,
    faFilePdf as falFilePdf,
    faBallot as falBallot,
    faFileSearch as falFileSearch,
    faBookAlt as falBookAlt,
    faBookOpen as falBookOpen,
    faArrowUp,
    faArrowDown,
    faChartLine,
    faArrowLeft as falArrowLeft,
    faArrowRight as falArrowRight,
    faRocketLaunch as falRocketLaunch,
    faGlobe as falGlobe,
    faClipboardListCheck as falClipboardListCheck,
} from '@fortawesome/pro-light-svg-icons'

import {
    faCheckCircle,
    faArrowCircleUp,
    faArrowCircleLeft,
    faArrowCircleRight,
    faArrowAltUp,
    faArrowAltLeft,
    faChevronDown,
    faDownload,
    faBallotCheck as fasBallotCheck,
    faBooks as fasBooks,
    faFileAlt as fasFileAlt,
    faBook as fasBook,
    faInfoSquare as fasInfoSquare,
    faInfo as fasInfo,
    faInfoCircle as fasInfoCircle,
    faFilePdf as fasFilePdf,
    faBallot as fasBallot,
    faFileSearch as fasFileSearch,
    faBookAlt as fasBookAlt,
    faBookOpen as fasBookOpen,
    faExclamationTriangle,
    faHeadset,
    faArrowLeft as fasArrowLeft,
    faArrowRight as fasArrowRight,
} from '@fortawesome/pro-solid-svg-icons'

import {
    faBallotCheck as fadBallotCheck,
    faBooks as fadBooks,
    faFileAlt as fadFileAlt,
    faBook as fadBook,
    faInfoSquare as fadInfoSquare,
    faInfo as fadInfo,
    faInfoCircle as fadInfoCircle,
    faFilePdf as fadFilePdf,
    faBallot as fadBallot,
    faFileSearch as fadFileSearch,
    faBookAlt as fadBookAlt,
    faBookOpen as fadBookOpen,
    faCircleNotch,
} from '@fortawesome/pro-duotone-svg-icons'

library.add(
    faChartLine,
    faCircleNotch,
    faArrowUp,
    faArrowDown,
    faHome,
    faCog,
    faUser,
    faCloudUploadAlt,
    faFile,
    faFileAlt,
    faTimes,
    faCheckCircle,
    faCheckCircleRegular,
    faBriefcase,
    faTasks,
    faUsers,
    faArrowCircleUp,
    faChevronDown,
    faSpinner,
    faTimesCircle,
    faDownload,
    farBallotCheck,
    farBooks,
    farBook,
    farInfoSquare,
    falBallotCheck,
    falBooks,
    falFileAlt,
    falBook,
    falInfoSquare,
    fasBallotCheck,
    fasBooks,
    fasFileAlt,
    fasBook,
    fasInfoSquare,
    fadBallotCheck,
    fadBooks,
    fadFileAlt,
    fadBook,
    fadInfoSquare,
    faArrowCircleLeft,
    faArrowCircleRight,
    faArrowAltUp,
    faArrowAltLeft,
    faFileDownload,
    farInfo,
    farInfoCircle,
    farFileAlt,
    farFilePdf,
    farBallot,
    farFileSearch,
    farBookAlt,
    farBookOpen,
    falInfo,
    falInfoCircle,
    falFilePdf,
    falBallot,
    falFileSearch,
    falBookAlt,
    falBookOpen,
    fasInfo,
    fasInfoCircle,
    fasFilePdf,
    fasBallot,
    fasFileSearch,
    fasBookAlt,
    fasBookOpen,
    fadInfo,
    fadInfoCircle,
    fadFilePdf,
    fadBallot,
    fadFileSearch,
    fadBookAlt,
    fadBookOpen,
    faExclamationTriangle,
    faHeadset,
    falRocketLaunch,
    falGlobe,
    falClipboardListCheck,
    farPenSquare,
    fasArrowLeft,
    fasArrowRight,
    falArrowLeft,
    falArrowRight,
    faEyeSlash,
)

Vue.component('font-awesome-icon', FontAwesomeIcon)
